<template :key="buildingId">
    <v-list align="center" justify="center">
        <v-list-item class="nav-item active">
            <router-link to="/" style="margin-left: 0px;margin-right:0px">
                <template v-if="mini">
                    <img src="/images/openplanmini.png"
                         alt="avatar"
                         style="
            width: 100%;height:auto;
           " />
                </template>

                <template v-else>
                    <img src="/images/openplan.png"
                         alt="avatar"
                         style="
            width: 100%;
           " />
                </template>

            </router-link>

        </v-list-item>

        <router-link :to="{ name: 'buildings' }">
            <v-list-item style="height:65px" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/realestate.png" /><span style="    text-align: left;
    line-height: 0.5;
    margin-top: 15px;" class="nav-title">Buildings</span>
            </v-list-item>
        </router-link>
        <router-link :to="{
          name: 'properties',
          params: { buildingId: buildingId, buildingName: buildingName },
        }">
            <v-list-item v-if="buildingId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/units.png" /><span class="nav-title">Units</span>
            </v-list-item>
        </router-link>

        <router-link :to="{
          name: 'controlpanel',
          params: {
            buildingId: buildingId,
            buildingName: buildingName,
          },
        }">
            <v-list-item v-if="buildingId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/controlpanel.png" /><span class="nav-title">Control Panel</span>
            </v-list-item>
        </router-link>
        <router-link :to="{ name: 'buildings' }">
            <v-list-item v-if="false" class="nav-item active">
                <img src="/images/menu/services.png" /><span class="nav-title">Services</span>
            </v-list-item>
        </router-link>
        <router-link :to="{
          name: 'revenues',
          params: { buildingId: buildingId, buildingName: buildingName },
        }">
            <v-list-item v-if="buildingId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/graphreports.png" /><span class="nav-title">Graph Reports</span>
            </v-list-item>
        </router-link>
        <router-link :to="{
          name: 'messages',
          params: { buildingId: buildingId, buildingName: buildingName },
        }">
            <v-list-item v-if="buildingId" :class="{'is-mini':mini}" class="nav-item active">
                <img src="/images/menu/notifications.png" /><span class="nav-title">Notifications</span>
            </v-list-item>
        </router-link>
        <template v-if="buildingId">
            <router-link class="more-nav-buttons"
                         :to="{
          name: 'expensetypes',
          params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                <v-list-item v-if="buildingId" class="nav-item active small">

                    <span class="nav-title small">Add New Expense Type</span>

                </v-list-item>
            </router-link>
            <router-link class="more-nav-buttons"
                         :to="{
          name: 'suppliers',
        params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                <v-list-item v-if="buildingId" class="nav-item active small">
                    <span class="nav-title small">Providers</span>
                </v-list-item>
            </router-link>
            <router-link class="more-nav-buttons"
                         :to="{
          name: 'recurringexpenses',
         params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                <v-list-item v-if="buildingId" class="nav-item active small">
                    <span class="nav-title small">Recurring Expenses</span>
                </v-list-item>
            </router-link>
            <router-link class="more-nav-buttons"
                         :to="{
          name: 'additionalindex',
         params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                <v-list-item v-if="buildingId" class="nav-item active small">
                    <span class="nav-title small">Additional Expenses</span>
                </v-list-item>
            </router-link>
            <router-link class="more-nav-buttons"
                         :to="{
          name: 'expensesbymonth',
      params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                <v-list-item v-if="buildingId" class="nav-item active small">
                    <span class="nav-title small">Additional Reports</span>
                </v-list-item>
            </router-link>
            <!--<v-list-item v-if="buildingId && ismore" class="nav-item active"><router-link class="more-nav-buttons" @click="trueMore" :to="{ name: 'more', params:{buildingId:buildingId, buildingName:buildingName}}">Tutorials</router-link></v-list-item>-->
            <router-link class="more-nav-buttons"
                         :to="{
          name: 'committees',
        params: { buildingId: this.buildingId, buildingName: this.buildingName },
        }">
                <v-list-item v-if="buildingId" class="nav-item active small">
                    <span class="nav-title small">Committee</span>
                </v-list-item>
            </router-link>
            <v-divider></v-divider>
        </template>
        <!--<v-list-item v-if="buildingId" :class="{'is-mini':mini}" class="nav-item active">
        <img src="/images/menu/more.png" /><a @click.prevent="toggledMore">
            <span class="nav-title" style="margin-left:0px">More</span>
        </a>
    </v-list-item>

    <router-link class="more-nav-buttons"
                     @click="trueMore"
                     :to="{
      name: 'expensetypes',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><v-list-item v-if="buildingId && ismore" class="nav-item active small">

            <span class="nav-title small">Add New Expense Type</span>

    </v-list-item> </router-link>
    <router-link class="more-nav-buttons"
                     @click="trueMore"
                     :to="{
      name: 'suppliers',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"> <v-list-item v-if="buildingId && ismore" class="nav-item active small">
       <span class="nav-title small">Providers</span>
    </v-list-item></router-link>
    <router-link class="more-nav-buttons"
                     @click="trueMore"
                     :to="{
      name: 'recurringexpenses',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><v-list-item v-if="buildingId && ismore" class="nav-item active small">
        <span class="nav-title small">Recurring Expenses</span>
    </v-list-item></router-link>
     <router-link class="more-nav-buttons"
                     @click="trueMore"
                     :to="{
      name: 'additionalindex',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><v-list-item v-if="buildingId && ismore" class="nav-item active small">
       <span class="nav-title small">Additional Expenses</span>
    </v-list-item></router-link>
    <router-link class="more-nav-buttons"
                     @click="trueMore"
                     :to="{
      name: 'expensesbymonth',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"> <v-list-item v-if="buildingId && ismore" class="nav-item active small">
       <span class="nav-title small">Additional Reports</span>
    </v-list-item></router-link>-->
        <!--<v-list-item v-if="buildingId && ismore" class="nav-item active"><router-link class="more-nav-buttons" @click="trueMore" :to="{ name: 'more', params:{buildingId:buildingId, buildingName:buildingName}}">Tutorials</router-link></v-list-item>-->
        <!--<router-link class="more-nav-buttons"
                      @click="trueMore"
                      :to="{
       name: 'committees',
       params: { buildingId: buildingId, buildingName: buildingName },
     }"> <v-list-item v-if="buildingId && ismore" class="nav-item active small">
         <span class="nav-title small">Committee</span>
     </v-list-item></router-link>-->
        <!-- <v-list-item v-if="buildingId && ismore" class="nav-item active"><router-link class="more-nav-buttons" @click="trueMore" :to="{ name: 'contacts', params:{buildingId:buildingId, buildingName:buildingName}}">Constacts List</router-link></v-list-item> -->
    </v-list>
</template>

<script>
import { EventBus } from "@/events";
import { router } from "@/_helpers";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      color: "#015A6C",
      ismore: false,
    };
  },
  props: {},
  watch: {
   
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.$forceUpdate();
    },
  },

  computed: {
    ...mapState(["mini"]),
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    mini: {
      get() {
        return this.$store.state.mini;
      },
      set(val) {
        this.$store.commit("SET_MINI", val);
      },
    },
    buildingId() {
      return this.building.id;
    },

    
  },
  mounted() {
    this.updatedHandler = function (payLoad) {
  //    this.buildingId = payLoad;
    };
    EventBus.$on("updated", this.updatedHandler);
  },
  beforeUnmount() {
    EventBus.$off("updated", this.updatedHandler);
    EventBus.$off("menuDrawerClicked", this.menuDrawerHandler);
  },
  methods: {
    toggledMore() {
      this.ismore = !this.ismore;
    },

    trueMore() {
      this.ismore = true;
    },
  },
  created() {
    this.menuDrawerHandler = (drawer) => {
      this.drawer = drawer;
    };
    EventBus.$on("menuDrawerClicked", this.menuDrawerHandler);
  },
};
</script>
